export const de = {
  monthsFull: [ 'Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember' ],
  monthsShort: [ 'Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez' ],
  weekdaysFull: [ 'Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag' ],
  weekdaysShort: [ 'So','Mo','Di','Mi','Do','Fr','Sa' ],
  today: 'Heute',
  clear: 'Löschen',
  close: 'Schließen',
  firstDay: 1,
  formatHint: 'tt.mm.jjjj',
  format: 'dd.mm.yyyy',
  formatSubmit: 'yyyy-mm-dd',
  labelMonthNext: 'nächste Monate',
  labelMonthPrev: 'voriger Monat',
  labelMonthSelect: 'Monat wählen',
  labelYearSelect: 'Jahr wählen',
  selectMonths: true,
  selectYears: true,
  closeOnSelect: true,
  closeOnClear: true,
  editable: false
};


export const en = {
  monthsFull: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
  monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
  weekdaysFull: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
  weekdaysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],
  today: 'Today',
  clear: 'Clear',
  close: 'Close',
  formatHint: 'dd/mm/yyyy',
  format: 'dd/mm/yyyy',
  formatSubmit: 'yyyy-mm-dd',
  labelMonthNext: 'Next month',
  labelMonthPrev: 'Previous month',
  labelMonthSelect: 'Select a month',
  labelYearSelect: 'Select a year',
  selectMonths: true,
  selectYears: true,
  closeOnSelect: true,
  closeOnClear: true,
  editable: false
};


export const es = {
  monthsFull: [ 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre' ],
  monthsShort: [ 'ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic' ],
  weekdaysFull: [ 'domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado' ],
  weekdaysShort: [ 'dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb' ],
  today: 'hoy',
  clear: 'borrar',
  close: 'cerrar',
  firstDay: 1,
  formatHint: 'dd/mm/aaaa',
  format: 'dd/mm/yyyy',
  formatSubmit: 'yyyy-mm-dd',
  labelMonthNext: 'mes siguiente',
  labelMonthPrev: 'mes anterior',
  labelMonthSelect: 'Seleccionar mes',
  labelYearSelect: 'Seleccionar año',
  selectMonths: true,
  selectYears: true,
  closeOnSelect: true,
  closeOnClear: true,
  editable: false
};


export const fr = {
  monthsFull: [ 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre' ],
  monthsShort: [ 'Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec' ],
  weekdaysFull: [ 'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi' ],
  weekdaysShort: [ 'Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam' ],
  today: 'Aujourd\'hui',
  clear: 'Effacer',
  close: 'Fermer',
  firstDay: 1,
  formatHint: 'jj/mm/aaaa',
  format: 'dd/mm/yyyy',
  labelMonthNext:'Mois suivant',
  labelMonthPrev:'Mois précédent',
  labelMonthSelect:'Sélectionner un mois',
  labelYearSelect:'Sélectionner une année',
  formatSubmit: 'yyyy-mm-dd',
  selectMonths: true,
  selectYears: true,
  closeOnSelect: true,
  closeOnClear: true,
  editable: false
};


export const it = {
  monthsFull: [ 'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre' ],
  monthsShort: [ 'gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic' ],
  weekdaysFull: [ 'domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato' ],
  weekdaysShort: [ 'dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab' ],
  today: 'Oggi',
  clear: 'Cancella',
  close: 'Chiudi',
  firstDay: 1,
  formatHint: 'gg.mm.aaaa',
  format: 'dd.mm.yyyy',
  formatSubmit: 'yyyy-mm-dd',
  labelMonthNext: 'Mese successivo',
  labelMonthPrev: 'Mese precedente',
  labelMonthSelect: 'Seleziona un mese',
  labelYearSelect: 'Seleziona un anno',
  selectMonths: true,
  selectYears: true,
  closeOnSelect: true,
  closeOnClear: true,
  editable: false
};


export const sv = {
  monthsFull: [ 'januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december' ],
  monthsShort: [ 'jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec' ],
  weekdaysFull: [ 'söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag' ],
  weekdaysShort: [ 'sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör' ],
  today: 'Idag',
  clear: 'Rensa',
  close: 'Stäng',
  firstDay: 1,
  formatHint: 'åååå-mm-dd',
  format: 'yyyy-mm-dd',
  formatSubmit: 'yyyy-mm-dd',
  labelMonthNext: 'Nästa månad',
  labelMonthPrev: 'Föregående månad',
  labelMonthSelect: 'Välj månad',
  labelYearSelect: 'Välj år',
  selectMonths: true,
  selectYears: true,
  closeOnSelect: true,
  closeOnClear: true,
  editable: false
};
